import { TrendingFeedPost } from "components";
import FeedLayout from "layouts/files/FeedLayout";
import { TreandingPageHeader } from "ui";

const Trending = () => {
    return (
        <FeedLayout pageTitle="trending">
            <div className="moment-mark-page pb-40">
                <TreandingPageHeader />

                <div className="trending-posts">
                    <TrendingFeedPost hashtag="demoHashtag1" />
                    <TrendingFeedPost
                        hashtag="demoHashtag2"
                        text="please choose between the two options"
                        mediaType={8}
                    />
                    <TrendingFeedPost hashtag="demoHashtag3" mediaType={5} />
                    <TrendingFeedPost hashtag="demoHashtag4" mediaType={9} />
                </div>
            </div>
        </FeedLayout>
    );
};

export default Trending;
